import React, { useEffect, useState }  from "react";
import "src/features/tables/station-table/stationDetails.scss";
import { useHistory, useLocation} from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import { Box, Tab } from "@mui/material";
import { ROUTE_PATHS } from "src/routes/paths";
import DeadCatalogTable from "./tabs/DeadCatalogTable";
import DroughtCatalogTable from "./tabs/DroughtCatalogTable";
import FuelModelCatalogTable from "./tabs/FuelModelTable";
import LiveFuelCatalogTable from "./tabs/LiveFuelTable";
import DeadCatalogDetail from "./catalog_detail/DeadCatalogDetail";
import DroughtCatalogDetail from "./catalog_detail/DroughtCatalogDetail";
import FuelModelCatalogDetail from "./catalog_detail/FuelModelCatalogDetail";
import LiveFuelCatalogDetail from "./catalog_detail/LiveFuelCatalogDetail";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          style={{padding:0, margin:0}}
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
      >
          {value === index && <Box>{children}</Box>}
      </div>
  );
};
function a11yProps(index: number) {
  return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
  };
}

const routes = [ROUTE_PATHS.fuelTab, ROUTE_PATHS.deadTab, ROUTE_PATHS.droughtTab, ROUTE_PATHS.liveTab]

export const Catalogs= () => {
  const history = useHistory();
  const location = useLocation();
  const [tabValue, setTabValue] = useState(0);

  useEffect(()=>{
      if (location.pathname === ROUTE_PATHS.catalogs) {
          history.push(`${routes[0]}`)
      }
      if (location?.pathname?.includes(ROUTE_PATHS.fuelTab)) {
          setTabValue(0)
      }
      else if (location?.pathname?.includes(ROUTE_PATHS.deadTab)) {
          setTabValue(1)
      }
      else if (location?.pathname?.includes(ROUTE_PATHS.droughtTab)) {
          setTabValue(2)
      }
      else if (location?.pathname?.includes(ROUTE_PATHS.liveTab)) {
          setTabValue(3)
      }
  },[history, location.pathname])

    const returnFuelCatalogTab = (route:string)=>{
    if(route?.includes('fuel/detail/')){
      return <FuelModelCatalogDetail tab={0}/>
    }
    else if(route?.includes('fuel/stationAssign/')){
      return <FuelModelCatalogDetail tab={1}/>
    }
    else if(route?.includes('fuel/audit/')){
      return <FuelModelCatalogDetail tab={2}/>
    }
    else{
      return <FuelModelCatalogTable/>
    }
  };
  const returnDeadCatalog = (route:string)=>{
    if(route?.includes('dead/detail/')){
      return <DeadCatalogDetail tab={0}/>
    }
    else if(route?.includes('dead/audit/')){
      return <DeadCatalogDetail tab={1}/>
    }
    else{
      return <DeadCatalogTable/>
    }
  };
  
  const returnDroughtCatalog = (route:string)=>{
    if(route?.includes('drought/detail/')){
      return <DroughtCatalogDetail tab={0}/>
    }
    else if(route?.includes('drought/audit/')){
      return <DroughtCatalogDetail tab={1}/>
    }
    else{
      return <DroughtCatalogTable/>
    }
  };
  
  return (
    <Box m={4}>
      
      <Tabs 
        scrollButtons={false}
        value={tabValue}
        onChange={(event, newVal)=>{
          setTabValue(newVal); 
          history.push(`${ROUTE_PATHS.table}${routes[newVal]}`)
        }}
        aria-label="custom tabs example"
        className="custom-tabs-catalogs"
      >
        <Tab label="Fuel Model Catalogs"{...a11yProps(0)}/>
        <Tab label="Dead Fuel Catalogs" {...a11yProps(1)}/>
        <Tab label="Drought Catalogs"{...a11yProps(2)}/>
        <Tab label="Live Fuel Catalogs"{...a11yProps(3)}/>

      </Tabs>
      <CustomTabPanel value={tabValue} index={0}>
        <Box border={1.5} borderRadius={1} borderColor={'#d4d4d4'}>
          {returnFuelCatalogTab(location.pathname)}
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={1}>
        <Box border={1.5} borderRadius={1} borderColor={'#d4d4d4'}>
          {returnDeadCatalog(location.pathname)}
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={2}>
        <Box border={1.5} borderRadius={1} borderColor={'#d4d4d4'}>
          {returnDroughtCatalog(location.pathname)}
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={3}>
        <Box border={1.5} borderRadius={1} borderColor={'#d4d4d4'}>
          {
            location.pathname?.includes('live/detail/')?
            <LiveFuelCatalogDetail tab={0}/>
            :
            (location.pathname?.includes('live/audit/') ?
              <LiveFuelCatalogDetail tab={2}/>
              :
              <LiveFuelCatalogTable/>
            )
            
          }
        </Box>
      </CustomTabPanel>
    </Box>
  );
};
